import {Button, Dialog, DialogActions, DialogContent, DialogContentText} from '@mui/material';
import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {useRecoilState} from 'recoil';
import {MODAL_LAYER_Z_INDEX} from '../../../ui/modal-layers';
import {useRefreshCompanyTariff} from '../hooks/use-refresh-company-tariff';
import {companyTariffRestrictionState} from '../stores/company-tariff.store';

export const CompanyTariffRestrictionDialog = () => {
  const [restriction, setRestriction] = useRecoilState(companyTariffRestrictionState);
  const refresh = useRefreshCompanyTariff();
  const {pathname} = useLocation();

  useEffect(() => {
    refresh();
  }, [pathname, refresh]);

  useEffect(() => {
    window.addEventListener('focus', refresh);
    return () => window.removeEventListener('focus', refresh);
  }, [refresh]);

  return (
    <Dialog
      open={!!restriction}
      aria-label="Информация о тарифе"
      aria-describedby="company-tariff-restriction-message"
      sx={{zIndex: MODAL_LAYER_Z_INDEX.feedbackModal}}
    >
      <DialogContent>
        <DialogContentText id="company-tariff-restriction-message">{restriction}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={() => setRestriction(null)}>
          Ок
        </Button>
      </DialogActions>
    </Dialog>
  );
};
